import React, { Fragment } from 'react'

import { Button } from 'ui/acro'

import CenteredInfoSection from '../CenteredInfoSection'
import InstructorCarousel from './InstructorCarousel'

const Instructors = ({ ...rest }) => (
  <Fragment>
    <CenteredInfoSection
      headline='Meet your Instructors'
      body='We work with the best so you can feel your best. Our team of top instructors will empower you to reach all your fitness and wellness goals and enjoy the journey on the way.'
      {...rest}
    >
      <Button
        variant='secondary'
        width={['100%', null, '300px']}
        as='a'
        className='unstyled'
        href='/explore/instructors'
        id={'home-view-instructors'}
        aria-label={`All Instructors`}
      >
        View Instructors
      </Button>
    </CenteredInfoSection>
    <InstructorCarousel />
  </Fragment>
)

export default Instructors
